import React from 'react';

const AwardsRecognitions = ({ data }) => {
  const { main_title, main_icon, awards_data } = data;
  const webUrl = process.env.REACT_APP_WEB_URL;

  return (
    <section className="dp-awards-section py-5" data-sal="fade" data-sal-duration="300">
      <div className="container">
        <div className="row" data-sal="slide-up" data-sal-duration="300">
          <div className="col-12 pt-lg-5 dp-heading-icon-wrapper" data-sal="fade">
            {main_icon && <img src={`${webUrl}${main_icon}`} alt="icon" className="dp-heading-icon" />}
            <h2 className="section-title text-capitalize">{main_title}</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-12 awards-wrapper">
            {awards_data?.map((award, index) => (
              <div key={index} className="single-award-wrapper" data-sal="fade" data-sal-duration="300">
                <p className="award-title">{award.title}</p>
                <p className="award-desc">{award.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardsRecognitions;